module.exports = __webpack_public_path__ + "img/Jump Casting32.11960db0.jpg";